import questionFilterListTemplate from './question_filter_list.template.html';

angular.module('westBerkshireEvents.questionFilterList').component('wbQuestionFilterList', {
  templateUrl: questionFilterListTemplate.id,
  controller: ['$scope', '$rootScope', '$location', '$window', WbQuestionFilterListController],
  controllerAs: "$questionFilterListCtrl",
  bindings: {
    selectFilter: '<',
    filterValues: '<',
    onFilterChanged: '&'
  }
});

function WbQuestionFilterListController($scope, $rootScope, $location, $window) {
  var self = this;

  const filter = self.selectFilter.name.toLocaleLowerCase().replace(' ', '_');

  // Get the value of the parameter
  let urlParams = $location.search()[filter];
  // Find the matching filter item
  let matching = self.selectFilter.question_items.filter(item => {
    return item.name == urlParams
  });
  // Apply the filter
  if (matching.length) {
    self.filterValues[self.selectFilter.name] = matching[0];
  }

  this.filterClicked = function (answer) {
    self.filterValues[self.selectFilter.name] = answer;
    $location.search(filter.trim(), answer.name);
    if (self.onFilterChanged) {
      self.onFilterChanged();
      $rootScope.$broadcast('page:changed');
    }
  };

  this.clearFilter = function () {
    console.log("fired");
    self.filterValues[self.selectFilter.name] = null;
    $location.search(filter, null);
    if (self.onFilterChanged) {
      self.onFilterChanged();
      $rootScope.$broadcast('page:changed');
    }
  };

  $scope.BannerFilter = function (type) {
    // Match filter to banner filter
    let matching = self.selectFilter.question_items.filter(item => {
      return item.name == type // Filter for banner
    });

    // Apply the filter
    if (matching.length) {
      self.filterValues[self.selectFilter.name] = matching[0];
      $location.search(filter, matching[0].name);
      if (self.onFilterChanged) {
        self.onFilterChanged();
        $rootScope.$broadcast('page:changed');
      }
    }
  }

  $scope.$on('ApplyQuestionFilter', function (evt, data) {
    $scope.BannerFilter(data);
  });

}



// WEBPACK FOOTER //
// src/public/javascripts/question-filter-list/question_filter_list.component.js